import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "store";

const selectDialogNotifications = (state: RootState) =>
  state.dialogNotifications;

const makeSelectCurrentDialogNotification = () =>
  createSelector(selectDialogNotifications, (substate) => {
    if (substate.notifications && substate.notifications.length) {
      return substate.notifications[0];
    }

    return null;
  });

export { makeSelectCurrentDialogNotification };
